import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

import { InputSize } from "./Input";

interface InputPrefixProps {
  children: ReactNode;
  inputSize?: InputSize;
  error?: boolean;
  disabled?: boolean;
}

export function InputPrefix({ children, inputSize = InputSize.MEDIUM, error, disabled }: InputPrefixProps) {
  const sizes = {
    [InputSize.SMALL]: "h-[26px] px-2",
    [InputSize.MEDIUM]: "h-[34px] px-2"
  };

  return (
    <div
      className={filterClasses(
        "body-sm flex items-center rounded-l-sm border border-r-0",
        disabled
          ? "border-grey-400 bg-grey-200 text-grey-500"
          : error
            ? "border-red-500 bg-grey-100 text-grey-900"
            : "border-grey-400 bg-grey-100 text-grey-900",
        sizes[inputSize]
      )}
    >
      {children}
    </div>
  );
}
